const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const viewClass = require('./view');
const modelClass = require('./model');
const {queue} = require('./queue');
const refundStatusNotificationManager = require('./refund_status_notification_manager/main');
const modificationStatusNotificationManager = require('./modifications_status_notification_manager/main');
module.exports = createWidgetFactory({
    name: 'notifications_manager',
    viewClass,
    modelClass,
    methods: {
        load(bookingData = {}, callback) {
            queue.clear();
            this.model.load(bookingData);
            if (!Odigeo.AB.isBookingImportantMessage) {
                refundStatusNotificationManager.load({
                    data: this.model.getRefundStatusData(),
                    keys: this.keys,
                    callback,
                });
            }
            modificationStatusNotificationManager.load({
                data: this.model.getRefundStatusData(),
                keys: this.keys,
                callback,
            });
        },

        loadStatus(notification) {
            queue.clear();
            queue.addNotification(notification);
        },

        addNotification(notification) {
            queue.addNotification(notification);
        },

        updateNotification(data) {
            queue.updateNotification(data);
        },

        deleteNotification(id) {
            queue.deleteNotification(id);
        },

        deleteAllNotifications() {
            queue.clear();
        },
    },
});
